export default {
  data() {
    return {
      hasUsingCustomApp: false
    };
  },
  methods: {
    checkForCustomApp() {
      this.$store.dispatch("hasUsingCustomApp").then(response => {
        if (response.hasCustomApp) {
          this.hasUsingCustomApp = true;
        }
      });
    }
  }
};
